$(function () {
  var legendCallback = function(chart) {
    var text = [];
    text.push('<ul class="chart__legend-list ' + chart.id + '-legend">');
    dataset = chart.data.datasets[0];
    for(var i=0; i < dataset.data.length; i++) {
      var label = chart.data.labels[i];
      text.push('<li>');
      text.push('<div class="chart__icon-wrapper--wide"><div class="chart__legend-icon" style="background-color:' + 
          dataset.backgroundColor[i] + ';"></div></div>');
      if (label) {
        text.push('<div class="chart__legend-text--narrow"><span>' + label + '</span></div>');
      }
      text.push('</li>');
    }
    text.push('</ul>');
    return text.join("");
  };

  $('[data-behavior=pie-chart]').existsEach(function ($pieChart) {
    var dataAttr = $pieChart.data('pie-chart');

    var datasets = dataAttr.datasets;
    var labels = dataAttr.labels;

    var legendContainer = $pieChart.find(dataAttr.legend);
    var canvas = $pieChart.find('canvas');


    var pieChart = new Chart(canvas, {
      type: 'pie',
      data: {
        labels: labels,
        datasets: datasets
      },
      
      options: {
        tooltips: {
          enabled: false
        },
        legend: {
          display: false
        },
        legendCallback: legendCallback,
        hover: {
          animationDuration: 0
        }
      }
    });
    $(legendContainer).html(pieChart.generateLegend());
  });
});
